import React from 'react';
import FormPurchaseItemsTable from '../tables/FormPurchaseItemTable';
import Error from '../../../../shared/error';


interface IItemsStep {
    filteredFields?: any;
    allRowsItems?: any;
    allRowsData?: any;
    filterErrors?: any;
    itemsLoading?: { row: number, loading: boolean };
    itemsGeneralError?: string;
    currency?: string
    onChangeInputValue: (e: any, type?: string, index?: any) => void;
    onClickAddRow: () => void;
    onDeleteItemRow: (id: any) => void;
    onCloneRow: (id: any) => void;
}

const ItemsStep = ({
    filteredFields,
    filterErrors,
    itemsGeneralError,
    allRowsItems,
    allRowsData,
    currency,
    onChangeInputValue,
    onClickAddRow,
    onDeleteItemRow,
    onCloneRow,
}: IItemsStep) => {
    const rowItems = allRowsItems && allRowsItems?.length > 0 && allRowsItems?.map((row: any, idx: number) => ({ ...row, index: idx }))
    const rowsData = allRowsData && allRowsData?.length > 0 && allRowsData?.map((row: any, idx: number) => ({ ...row, index: idx }))
    const allFields = ['itemName', 'quantity', 'price']
    return (
        <div className='min-w-[100%] bg-white p-3'>
            <p className='font-bold mb-2'>Items</p>
            <p className='mb-5'>Register all items and their informations. On the table below you can write item details and add multiple items if needed.</p>
            {itemsGeneralError && <Error text={itemsGeneralError} />}
            <div>
                <div className='border-b-2 border-[#e4e4e4]'>
                    <FormPurchaseItemsTable
                        filterErrors={filterErrors}
                        allRowsItems={rowItems}
                        allRowsData={rowsData}
                        onChangeInputValue={onChangeInputValue}
                        onDeleteItemRow={onDeleteItemRow}
                        onClickAddRow={onClickAddRow}
                        onCloneRow={onCloneRow}
                        currency={currency}
                    />
                </div>
            </div>
        </div>
    );
};

export default ItemsStep;
